import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { TylerMatTableDataSource } from '../../../../shared-components/angular-material/extended.class';
import { detailExpand } from '../../../../shared-components/angular-material/mat-animations';
import { System } from '../../../../shared-components/System';
import { ReportV9 } from '../../../../shared-modules/reporting/models/report-v9.model';
import { ReportingService } from '../../../../shared-modules/reporting/reporting.service';
import { AssignedReports, MyReportsFolder } from '../../reporting-framework.model';
import { ReportingFrameworkService } from '../../reporting-framework.service';

@Component({
  selector: 'manage-reports-in-folder',
  templateUrl: './manage-reports-in-folder.component.html',
  styleUrls: ['./manage-reports-in-folder.component.css'],
  animations: [detailExpand]
})
export class ManageReportsInFolderComponent implements OnInit {

  folderName = '';
  isMyReportPage: boolean;
  reportFolder: MyReportsFolder;
  assignedReportFolder: AssignedReports;

  reports: ReportV9[] = [];
  reportModules: ReportV9[] = [];

  reportsTableColumns = ['ParentCheckbox', 'More', 'Description'];
  reportTableColumns = ['CheckBox', 'ReportName'];
  reportsTableData = new TylerMatTableDataSource();
  isReportsRowsExpanded = false;

  parentAllCheckBox = false;
  checkIndeterminate = false;

  constructor(
    private dialogRef: MatDialogRef<ManageReportsInFolderComponent>,
    private reportingService: ReportingService,
    private reportingFrameworkService: ReportingFrameworkService
  ) { }

  ngOnInit() {
    if (this.isMyReportPage == true) {
      this.folderName = this.reportFolder.FolderName;
    } else {
      this.folderName = this.assignedReportFolder.FolderName;
    }
    this.getMyV9Reports();
  }

  getMyV9Reports(): void {
    this.reportingService.getV9Reports('TeacherMenu').subscribe(rpt => {

      if (this.reportingService.inDebugMode) {
        console.log(rpt);
      }

      // remove progress report for now, can only get to it from the gradebook
      let i = 0;
      rpt.forEach(f => {
        const ri = f.ReportsList.filter(r => r.ReportName != 'GradeBookProgressReport');
        if (i >= 0) {
          rpt[i].ReportsList = System.convert<ReportV9[]>(ri, new Array<ReportV9>());
        }
        i++;
      }
      );

      this.reports = System.convert<ReportV9[]>(rpt, new Array<ReportV9>());

      const IsReportsList: boolean = rpt.filter(x => x.ReportsList.length > 0).length > 0;
      if (IsReportsList == true) {
        this.reportModules = rpt.filter(x => x.ParentId == 0);
      } else {
        this.reports = [];
        const obj = new ReportV9();
        obj.Id = 0;
        obj.ReportsList = rpt;
        this.reports.push(obj);
      }

      this.reports.forEach(report => {
        // If report is in folder report check box = true
        report.ReportsList.forEach(rt => {
          if (this.isMyReportPage == true) {
            if (this.reportFolder.ReportsInFolder.find(x => x.ReportId == rt.Id) != null) {
              rt.IsSelected = true;
            }
          } else {
            if (this.assignedReportFolder.AssignedReportsInFolder.find(x => x.ReportId == rt.Id) != null) {
              rt.IsSelected = true;
            }
          }

        });

        // If All report in folder so parent check box = true
        if (report.ReportsList.filter(x => x.IsSelected == true).length == report.ReportsList.length) {
          report.IsSelected = true;
        }


        this.childCheckBoxChange(report);
      });

      this.reportsTableData.data = this.reports;
    });
  }

  expandAll(expand: boolean) {
    // POST: expands or collapses application area rows
    this.isReportsRowsExpanded = !expand;
    this.reportsTableData.data.forEach(report => {
      report.detailRow = this.isReportsRowsExpanded;
    });
  }

  parentAllCheckBoxChange() {
    this.reports.forEach(rpt => {
      rpt.IsSelected = this.parentAllCheckBox;
      rpt.checkRowIndeterminate = false;

      rpt.ReportsList.forEach(rt => {
        rt.IsSelected = this.parentAllCheckBox;
      });
    });

    this.checkIndeterminate = false;

    // const selectedCount = this.reportsTableData.data.filter(x => x.IsSelected == true).length;
    // if (selectedCount > 0) {
    //   if (this.reportsTableData.data.length === selectedCount) {
    //     this.parentAllCheckBox = true;
    //     this.checkIndeterminate = false;
    //   }
    //   else {
    //     this.checkIndeterminate = true;
    //   }
    // } else {
    //   this.checkIndeterminate = false;
    // }
  }

  parentCheckBoxChange(rpt: ReportV9) {
    rpt.ReportsList.forEach(rt => {
      rt.IsSelected = rpt.IsSelected;
    });
    rpt.checkRowIndeterminate = false;

    const selectedCount = this.reportsTableData.data.filter(x => x.IsSelected == true || x.checkRowIndeterminate == true).length;
    if (selectedCount > 0) {
      if (this.reportsTableData.data.length === selectedCount) {
        this.parentAllCheckBox = true;
        this.checkIndeterminate = false;
      }
      else {
        this.checkIndeterminate = true;
        this.parentAllCheckBox = false;
      }
    } else {
      this.checkIndeterminate = false;
      this.parentAllCheckBox = false;
    }
  }

  childCheckBoxChange(rpt: ReportV9) {
    const selectedCount = rpt.ReportsList.filter(x => x.IsSelected == true).length;
    if (selectedCount > 0) {
      if (rpt.ReportsList.length === selectedCount) {
        rpt.IsSelected = true;
        rpt.checkRowIndeterminate = false;
      }
      else {
        rpt.checkRowIndeterminate = true;
        rpt.IsSelected = false;
      }
    } else {
      rpt.checkRowIndeterminate = false;
      rpt.IsSelected = false;
    }


    if (this.reports.find(x => x.IsSelected == true || x.checkRowIndeterminate == true) != null) {
      this.checkIndeterminate = true;
      this.parentAllCheckBox = false;
    } else {
      this.checkIndeterminate = false;
    }
  }

  saveClick() {
    const reportIds: Number[] = [];
    this.reports.forEach(rpt => {
      rpt.ReportsList.forEach(rt => {
        if (rt.IsSelected == true) {
          reportIds.push(rt.Id);
        }
      });
    });
    if (this.isMyReportPage == true) {
      this.reportingFrameworkService.saveReportsInFolder(this.reportFolder.Id, reportIds).subscribe(result => {
        if (result == true) {
          this.dialogRef.close('save');
        }
      });
    } else {
      this.reportingFrameworkService.saveAssignedReportsInFolder(this.assignedReportFolder.Id, reportIds).subscribe(result => {
        if (result == true) {
          this.dialogRef.close('save');
        }
      });
    }

  }

  cancelClick() {
    this.dialogRef.close('cancel');
  }

}
